export default __webpack_public_path__ + "static/media/tips.cf5f1144.svg";